// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"gO-z","carouselContainer":"hO-z"};